document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.f8vl a.show span:first-child').forEach(function (el) {
    if (el.textContent.trim() === 'Toon') el.textContent = 'Show';
  });

  var quoteProductPath = '/products/7inch-custom-inspection-rigging-tags';

  function fixQuoteOnlyCards() {
    document.querySelectorAll('a[href*="' + quoteProductPath + '"]').forEach(function (link) {
      var card = link.closest('.product-card');
      if (!card || card.dataset.archfordQuoteCard === 'true') return;
      card.dataset.archfordQuoteCard = 'true';
      card.querySelectorAll('form.form-card').forEach(function (form) { form.remove(); });
      var price = card.querySelector('.price');
      if (price) price.innerHTML = '<a class="archford-quote-card-cta" href="' + quoteProductPath + '">Request a Quote</a>';
      card.querySelectorAll('a.overlay-buy_button').forEach(function (button) {
        button.href = quoteProductPath;
        button.removeAttribute('data-quickshop');
        button.textContent = 'Request a Quote';
      });
    });
  }

  function fixHomeLegacyLayouts() {
    var uspSection = document.querySelector('[id$="__archford_usp"]');
    var usp = uspSection ? uspSection.querySelector('ul') : null;
    if (usp && usp.className !== 'archford-home-usps') {
      usp.className = 'archford-home-usps';
      usp.removeAttribute('style');
      Array.prototype.forEach.call(usp.children, function (item) {
        if (item.tagName !== 'LI') return;
        item.className = 'archford-home-usps__item';
        item.removeAttribute('style');
      });
    }
    var categoriesSection = document.querySelector('[id$="__archford_core_collections"]');
    var categories = categoriesSection ? categoriesSection.querySelector('ul') : null;
    if (categories && categories.className !== 'archford-home-category-grid') {
      categories.className = 'archford-home-category-grid';
      categories.removeAttribute('style');
      Array.prototype.forEach.call(categories.children, function (item) {
        if (item.tagName !== 'LI') return;
        item.className = 'archford-home-category-card';
        item.removeAttribute('style');
      });
    }
  }

  function findDetailsBySummary(root, summaryText) {
    if (!root) return null;
    var found = null;
    root.querySelectorAll('details').forEach(function (details) {
      var summary = details.querySelector('summary');
      if (summary && summary.textContent.trim() === summaryText) found = details;
    });
    return found;
  }

  function removeFaqs(root, questions) {
    questions.forEach(function (question) {
      var item = findDetailsBySummary(root, question);
      if (item) item.remove();
    });
  }

  function keepOnlyLink(container, matcher) {
    if (!container) return;
    container.querySelectorAll('a').forEach(function (link) {
      if (!matcher(link)) link.remove();
    });
  }

  function removeSectionByHeading(text) {
    document.querySelectorAll('h2,h3').forEach(function (heading) {
      if (heading.textContent.trim() !== text) return;
      var section = heading.closest('section');
      if (section) section.remove();
    });
  }

  function addFinalQuoteCta(label) {
    if (document.querySelector('.archford-content-depth-final')) return;
    var wrap = document.createElement('section');
    wrap.className = 'archford-content-depth-final';
    wrap.innerHTML = '<div class="archford-content-depth-final__inner"><h2>' + label + '</h2><p>Send Archford USA the application, quantity and specification so the team can review the requirement and prepare the correct quotation pathway.</p><a href="/pages/custom-labels">Request a Custom Quote</a></div>';
    var main = document.querySelector('#content') || document.querySelector('main') || document.body;
    main.appendChild(wrap);
  }

  function applyContentDepthPass() {
    if (document.documentElement.dataset.archfordContentDepth === 'true') return;
    var path = window.location.pathname.replace(/\/$/, '');

    if (path === '/collections/lifting-rigging-inspection-tags') {
      document.querySelectorAll('.archford-rig-custom .archford-rig-lead').forEach(function (p) {
        if (p.textContent.indexOf('Minimum order: 1,000 custom tags') !== -1) p.textContent = 'Custom pricing, order minimums and lead times are confirmed after we review your specification and quantity.';
      });
      document.querySelectorAll('.archford-rig-table td').forEach(function (td) {
        if (td.textContent.trim() === 'MOQ 1,000') td.textContent = 'Quote required';
      });
      var rigFaq = document.querySelector('.archford-rig-faq');
      var customRigFaq = findDetailsBySummary(rigFaq, 'Can I order custom rig tags?');
      if (customRigFaq) {
        var answer = customRigFaq.querySelector('p');
        if (answer) answer.textContent = 'Yes. Custom branding, numbering, text, layout and color requirements are reviewed by Archford USA. Pricing, order minimums and lead times are confirmed after we review your specification and quantity.';
      }
      removeFaqs(rigFaq, ['How do I contact Archford USA?']);
      var rigFinal = document.querySelector('.archford-rig-final');
      if (rigFinal) {
        var copy = rigFinal.querySelector('div > p:not(.archford-rig-kicker):not(.archford-rig-final__contact)');
        if (copy) copy.textContent = 'Ready to order from the standard range? Choose the rig-tag format that matches your inspection system.';
        keepOnlyLink(rigFinal.querySelector('.archford-rig-final__links'), function (link) { return link.getAttribute('href') === '#collection'; });
      }
    }

    if (path === '/collections/safety-tags') {
      var safetyCustom = document.querySelector('.archford-safety-custom');
      if (safetyCustom) {
        var lead = safetyCustom.querySelector('.archford-safety-lead');
        if (lead) lead.textContent = 'Custom messaging, branding, non-standard quantities and larger requirements are reviewed by Archford USA so pricing, order minimums and timing can be confirmed against your specification.';
        keepOnlyLink(safetyCustom.querySelector('.archford-safety-btns'), function (link) { return link.getAttribute('href') === '/pages/custom-labels'; });
      }
      var safetyFinal = document.querySelector('.archford-safety-final');
      if (safetyFinal) {
        var safetyCopy = safetyFinal.querySelector('div > p:not(.archford-safety-kicker):not(.archford-safety-final__contact)');
        if (safetyCopy) safetyCopy.textContent = 'Ready to order? Choose the safety-tag message and pack size that fits your site.';
        keepOnlyLink(safetyFinal.querySelector('.archford-safety-final__links'), function (link) { return link.getAttribute('href') === '#collection'; });
      }
    }

    if (path === '/collections/rubber-tag' || path === '/collections/rubber-tags') {
      var rubberSampleActions = document.querySelector('.archford-rubber__sample-actions');
      if (rubberSampleActions) keepOnlyLink(rubberSampleActions, function (link) { return link.getAttribute('href') === '/pages/get-a-free-sample'; });
      removeFaqs(document.querySelector('.archford-rubber__faq-list'), ['What comes in a pack?', 'What colors are available?', 'What size are the tags?']);
      var rubberClosing = document.querySelector('.archford-rubber__closing');
      if (rubberClosing) {
        var rubberHeading = rubberClosing.querySelector('h2');
        var rubberText = rubberClosing.querySelector('p:not(.archford-rubber__eyebrow)');
        if (rubberHeading) rubberHeading.textContent = 'Ready to choose your rubber inspection tags?';
        if (rubberText) rubberText.textContent = 'Compare the two active formats above and order the one that matches your inspection system.';
        var rubberActions = rubberClosing.querySelector('.archford-rubber__actions');
        if (rubberActions) rubberActions.innerHTML = '<a class="archford-rubber__button archford-rubber__button--orange" href="#rubber-tag-products">Shop Rubber Tags</a>';
      }
    }

    if (path === '/collections/scaffold-tags') {
      var scaffoldSteps = document.querySelectorAll('.archford-scaffold__system-step p');
      if (scaffoldSteps[0]) scaffoldSteps[0].textContent = 'Use the complete kit when you need a new Archford scaffold-tagging setup.';
      if (scaffoldSteps[1]) scaffoldSteps[1].textContent = 'Add compatible holder packs where you need more display points.';
      if (scaffoldSteps[2]) scaffoldSteps[2].textContent = 'Replenish used inserts without replacing the full system.';
      var scaffoldSampleActions = document.querySelector('.archford-scaffold__sample-actions');
      if (scaffoldSampleActions) keepOnlyLink(scaffoldSampleActions, function (link) { return (link.getAttribute('href') || '').indexOf('mailto:') === 0; });
      removeFaqs(document.querySelector('.archford-scaffold__faq-list'), ['What comes in the Scaffold Tag Kit?', 'What are the holder dimensions?', 'What are the replacement tag dimensions?']);
      var scaffoldClosing = document.querySelector('.archford-scaffold__closing');
      if (scaffoldClosing) {
        var scaffoldHeading = scaffoldClosing.querySelector('h2');
        var scaffoldText = scaffoldClosing.querySelector('p:not(.archford-scaffold__eyebrow)');
        if (scaffoldHeading) scaffoldHeading.textContent = 'Ready to order your scaffold tagging components?';
        if (scaffoldText) scaffoldText.textContent = 'Choose the complete kit, holders or replacement inserts from the current range above.';
        var scaffoldActions = scaffoldClosing.querySelector('.archford-scaffold__actions');
        if (scaffoldActions) scaffoldActions.innerHTML = '<a class="archford-scaffold__button archford-scaffold__button--orange" href="#scaffold-products">Shop Scaffold Tags</a>';
      }
    }

    if (path === '/collections/asset-labels-stickers') {
      document.querySelectorAll('.archford-assets__spec-list > div').forEach(function (row) {
        var name = row.querySelector('span');
        var value = row.querySelector('strong');
        if (name && value && name.textContent.trim() === 'Catalog ranges') {
          name.textContent = 'Numbering';
          value.textContent = 'Sequential ranges — confirm availability';
        }
      });
      removeFaqs(document.querySelector('.archford-assets__faq-list'), ['How many labels are in a pack?', 'What size are the barcode asset labels?', 'What size are the QR code asset labels?', 'What numbering ranges are listed?']);
      var assetSampleActions = document.querySelector('.archford-assets__sample-actions');
      if (assetSampleActions) keepOnlyLink(assetSampleActions, function (link) { return (link.getAttribute('href') || '').indexOf('mailto:') === 0; });
      var assetClosing = document.querySelector('.archford-assets__closing');
      if (assetClosing) {
        var assetHeading = assetClosing.querySelector('h2');
        var assetText = assetClosing.querySelector('p:not(.archford-assets__eyebrow)');
        if (assetHeading) assetHeading.textContent = 'Need asset labels for your equipment or inventory?';
        if (assetText) assetText.textContent = 'Send us the format, quantity and numbering requirement so we can confirm current availability and the right ordering pathway.';
        var assetActions = assetClosing.querySelector('.archford-assets__actions');
        if (assetActions) assetActions.innerHTML = '<a class="archford-assets__button archford-assets__button--orange" href="mailto:sales@archfordusa.com?subject=Asset%20Label%20Requirements">Contact Sales</a>';
      }
    }

    if (path === '/collections/custom-labels') {
      removeFaqs(document.querySelector('.afcl__faq'), ['How do I request a custom quote?']);
      var quoteActions = document.querySelector('.afcl__quote-actions');
      if (quoteActions) keepOnlyLink(quoteActions, function (link) { return link.getAttribute('href') === '/pages/custom-labels'; });
      var customClosing = document.querySelector('.afcl__closing');
      if (customClosing) {
        var customHeading = customClosing.querySelector('h2');
        var customText = customClosing.querySelector('p:not(.afcl__eyebrow)');
        if (customHeading) customHeading.textContent = 'Ready to specify your custom labels?';
        if (customText) customText.textContent = 'Send the application, approximate size, environment, quantity and artwork information you already know. Pricing, minimums and lead times are confirmed after review.';
        var customLinks = customClosing.querySelector('.afcl__links');
        if (customLinks) customLinks.innerHTML = '<a class="afcl__btn afcl__btn--orange" href="/pages/custom-labels">Request a Custom Quote</a>';
      }
    }

    if (path === '/pages/custom-labels') {
      var intro = document.querySelector('[id$="__intro"]');
      if (intro) {
        var introText = intro.querySelector('p');
        if (introText) introText.textContent = 'Tell us the application, approximate size, environment, quantity and information you need printed. Archford USA will review the specification and confirm pricing, order minimums and lead time as part of the quote.';
      }
    }

    if (path === '/pages/about-us') {
      var heroActions = document.querySelector('.archford-about-hero .archford-about-actions');
      if (heroActions) keepOnlyLink(heroActions, function (link) { return link.getAttribute('href') === '/collections/all'; });
      var aboutFinal = document.querySelector('.archford-about-final');
      if (aboutFinal) {
        var aboutActions = aboutFinal.querySelector('.archford-about-actions');
        if (aboutActions) keepOnlyLink(aboutActions, function (link) { return link.getAttribute('href') === '/pages/contact'; });
      }
    }

    if (path === '/collections/lockout-tagout') {
      var mainLotoFinal = document.querySelector('.aflc__final');
      if (mainLotoFinal) keepOnlyLink(mainLotoFinal.querySelector('.aflc__actions'), function (link) { return link.getAttribute('href') === '#collection'; });
      var reqSupport = document.querySelector('.aflc__support .aflc__actions');
      if (reqSupport) keepOnlyLink(reqSupport, function (link) { return link.getAttribute('href') === '/pages/contact'; });
    }

    if (path === '/collections/lockout-padlocks') {
      removeFaqs(document.querySelector('.aflp__faq'), ['Which lockout padlocks are currently available online?', 'Which colors are currently offered?', 'What keyed-alike set sizes are currently available?', 'Which materials are in the current online range?']);
      var padlockFinal = document.querySelector('.aflp__final');
      if (padlockFinal) keepOnlyLink(padlockFinal.querySelector('.aflp__actions'), function (link) { return link.getAttribute('href') === '#collection'; });
    }

    if (path === '/collections/lockout-tags') {
      removeFaqs(document.querySelector('.aflt__faq'), ['Which tag products are currently available online in this collection?', 'What pack formats are configured?', 'What size are the current tearproof poly tags?', 'Can I request samples?']);
      var tagFinal = document.querySelector('.aflt__final');
      if (tagFinal) keepOnlyLink(tagFinal.querySelector('.aflt__actions'), function (link) { return link.getAttribute('href') === '#collection'; });
    }

    if (path === '/collections/lockout-kits' || path === '/collections/loto-kits') {
      var kitSampleActions = document.querySelector('.aflk__sample .aflk__actions');
      if (kitSampleActions) keepOnlyLink(kitSampleActions, function (link) { return (link.getAttribute('href') || '').indexOf('mailto:') === 0; });
      var kitFinal = document.querySelector('.aflk__final');
      if (kitFinal) keepOnlyLink(kitFinal.querySelector('.aflk__actions'), function (link) { return link.getAttribute('href') === '#kit-selector'; });
    }

    if (path === '/pages/lockout-tagout') {
      removeSectionByHeading('Complete Kit or Individual Components?');
      removeFaqs(document.querySelector('.archford-loto-faq'), ['How do I contact Archford USA?']);
      var supportActions = document.querySelector('.archford-loto-support .archford-loto-btns');
      if (supportActions) keepOnlyLink(supportActions, function (link) { return link.getAttribute('href') === '/pages/contact'; });
      var lotoFinal = document.querySelector('.archford-loto-final');
      if (lotoFinal) keepOnlyLink(lotoFinal.querySelector('.archford-loto-final__links'), function (link) { return link.getAttribute('href') === '/pages/contact'; });
    }

    if (path === quoteProductPath) {
      document.querySelectorAll('.archford-product-help p').forEach(function (p) {
        if (p.textContent.indexOf('Minimum order quantity: 1,000 tags') !== -1) p.textContent = 'Pricing, order minimums and lead time are confirmed after Archford USA reviews the specification and required quantity.';
      });
      removeFaqs(document.querySelector('.section-faq, .faq, [class*="faq"]'), ['What is the minimum order quantity?']);
      document.querySelectorAll('h2').forEach(function (heading) {
        if (heading.textContent.trim() === 'Related Industrial Identification Products') {
          var section = heading.closest('.shopify-section') || heading.closest('section');
          if (section) section.remove();
        }
      });
      addFinalQuoteCta('Ready to request your custom rig tags?');
    } else if (document.body.classList.contains('template-product') || document.documentElement.classList.contains('template-product')) {
      var support = document.querySelector('.afp-support');
      if (support) {
        var supportHeading = support.querySelector('h2');
        var supportCopy = support.querySelector('p:not(.afp-kicker):not(.afp-support__contact)');
        if (supportHeading) supportHeading.textContent = 'Ready to order?';
        if (supportCopy) supportCopy.textContent = 'Return to the product options above to confirm the variant, quantity and current availability before adding to cart.';
        var supportActionsStandard = support.querySelector('.afp-actions');
        if (supportActionsStandard) supportActionsStandard.innerHTML = '<a class="afp-btn afp-btn--orange" href="#main-product">Choose Options &amp; Add to Cart</a>';
      }
      var choiceHelp = document.querySelector('.archford-product-help__links');
      if (choiceHelp) keepOnlyLink(choiceHelp, function (link) { return (link.getAttribute('href') || '').indexOf('mailto:') === 0; });
      removeFaqs(document.querySelector('.section-faq, .faq, [class*="faq"]'), ['How can I contact Archford USA?']);
    }

    if (document.querySelector('h3') && Array.from(document.querySelectorAll('h3')).some(function (h) { return h.textContent.trim() === 'Custom product — quotation required'; })) {
      document.querySelectorAll('h2').forEach(function (heading) {
        if (heading.textContent.trim() === 'You may also like') {
          var section = heading.closest('.shopify-section') || heading.closest('section');
          if (section) section.remove();
        }
      });
      addFinalQuoteCta('Ready to request a tailored quotation?');
    }

    document.documentElement.dataset.archfordContentDepth = 'true';
  }

  if (!document.getElementById('archford-quote-card-style')) {
    var style = document.createElement('style');
    style.id = 'archford-quote-card-style';
    style.textContent = '.archford-quote-card-cta{display:inline-flex;align-items:center;min-height:36px;padding:7px 12px;border:1px solid #ED9332;border-radius:6px;background:#ED9332;color:#000746!important;font-weight:800;text-decoration:none!important;line-height:1.2}.archford-quote-card-cta:hover{background:#D67D1F;border-color:#D67D1F}.archford-content-depth-final{padding:48px 20px;background:#000746;color:#fff}.archford-content-depth-final__inner{max-width:920px;margin:0 auto;text-align:center}.archford-content-depth-final h2{margin:0 0 10px;color:#fff}.archford-content-depth-final p{max-width:700px;margin:0 auto 20px;color:rgba(255,255,255,.88)}.archford-content-depth-final a{display:inline-flex;align-items:center;justify-content:center;min-height:48px;padding:12px 22px;border-radius:6px;background:#ED9332;color:#000746!important;font-weight:800;text-decoration:none!important}.archford-content-depth-final a:hover{background:#D67D1F}';
    document.head.appendChild(style);
  }

  fixQuoteOnlyCards();
  fixHomeLegacyLayouts();
  applyContentDepthPass();
  window.setTimeout(fixHomeLegacyLayouts, 80);
  window.setTimeout(fixHomeLegacyLayouts, 500);
  window.setTimeout(applyContentDepthPass, 80);

  var observer = new MutationObserver(function () {
    fixQuoteOnlyCards();
    fixHomeLegacyLayouts();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
